import {
  Theme,
  ComponentsProps,
  ComponentsOverrides,
  ComponentsVariants,
} from '@mui/material/styles';
import { palette } from 'themeV5/palette/light';

const styles = {
  backgroundColor: palette.gray['100'],
  '& .MuiOutlinedInput-input': {
    padding: 13,
  },
  '& .MuiInputBase-inputSizeSmall': {
    padding: '8.5px 14px',
  },
  '& $notchedOutline': {
    borderColor: palette.gray['600'],
  },
  '&.MuiOutlinedInput-notchedOutline': {
    borderColor: palette.gray['600'],
  },
  '&:hover $notchedOutline': {
    borderColor: palette.purple['400'],
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: palette.purple['400'],
  },
  '&$focused $notchedOutline': {
    borderColor: palette.purple['400'],
  },
  '&$colorSecondary $notchedOutline': {
    borderColor: palette.blue['300'],
  },
  '&.MuiInputBase-colorSecondary .MuiOutlinedInput-notchedOutline': {
    borderColor: palette.blue['300'],
  },
  '& .$colorSecondary .MuiSvgIcon-root': {
    fill: palette.blue['300'],
  },
  '&.MuiInputBase-colorSecondary .MuiSvgIcon-root': {
    fill: palette.blue['300'],
  },
  '&$colorSecondary:hover $notchedOutline': {
    borderColor: palette.blue['300'],
  },
  '&$colorSecondary$focused $notchedOutline': {
    borderColor: palette.blue['300'],
  },
  '&$disabled $notchedOutline': {
    borderColor: palette.gray['600'],
  },
  '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
    borderColor: palette.gray['600'],
  },
  '&$colorSecondary + .MuiFormHelperText-root': {
    color: palette.info.main,
  },
};

const muiOutlinedInput: {
  defaultProps?: ComponentsProps['MuiOutlinedInput'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiOutlinedInput'];
  variants?: ComponentsVariants['MuiOutlinedInput'];
} = {
  styleOverrides: {
    root: ({ theme }) => {
      const style = theme.palette.mode === 'light' ? styles : {};
      return {
        fontSize: 14,
        borderRadius: '8px',
        ...style,
      };
    },
  },
};

export default muiOutlinedInput;
